// SearchHost — owns the single SearchPalette instance and the global
// shortcuts (Cmd/Ctrl+K everywhere; "/" when not typing in a field).
// Triggers anywhere in the app open it via the ktp:search-open event.

import { lazy, Suspense, useEffect, useState } from "react";
import { SEARCH_OPEN_EVENT } from "./SearchButton";

const SearchPalette = lazy(() => import("./SearchPalette"));

export default function SearchHost() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    const onKey = (e: KeyboardEvent) => {
      const inField =
        e.target instanceof HTMLElement &&
        (e.target.tagName === "INPUT" ||
          e.target.tagName === "TEXTAREA" ||
          e.target.isContentEditable);
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setOpen((v) => !v);
      } else if (e.key === "/" && !inField && !e.metaKey && !e.ctrlKey && !e.altKey) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener(SEARCH_OPEN_EVENT, onOpen);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener(SEARCH_OPEN_EVENT, onOpen);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <SearchPalette open={open} onClose={() => setOpen(false)} />
    </Suspense>
  );
}
